module.exports = __webpack_public_path__ + "static/img/SC1.8ea6fcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC1.jpg
// module id = ME5b
// module chunks = 0